import { render, staticRenderFns } from "./AffiliateDetailRow.vue?vue&type=template&id=6d352753&scoped=true"
import script from "./AffiliateDetailRow.vue?vue&type=script&lang=js"
export * from "./AffiliateDetailRow.vue?vue&type=script&lang=js"
import style0 from "./AffiliateDetailRow.vue?vue&type=style&index=0&id=6d352753&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d352753",
  null
  
)

export default component.exports